import Information from 'features/otp/information/Information';
import React from 'react';

export default function Page() {
  return <Information />;
}
